import Route from '@ember/routing/route';

export default class MarketingRoute extends Route {}
